import React, { Component } from 'react';
import { connect } from 'react-redux';
import { format } from 'date-fns';
import { withRouter } from 'react-router';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';

import Page from '../../common-components/Page';

import * as reducers from '../reducer';
import * as userStationsReducers from '../../system/reducer/UserStationsReducers';

import * as actionMgr from '../action-mgr';
import * as errorReprotDialogActionMgr from '../../error-reports/aciton-mgr/ReportDialog';

import * as strings from '../../helpers/strings';
import { ERROR_TYPE_NOT_CONNECTED, topicPrefix } from '../constants';

import * as mqttMgr from '../../helpers/MqttMgr';
// importing Css
import '../../index.css';
// import PaperContainer from '../../common-components/PaperContainer';

var fetchHealthDataInterval;

const styles = {
  statusColorBox: {
    height: 39,
    width: 50
  }
}

const tableHeadCellStyle = {
  fontSize: '1rem',
  fontWeight: 500
}

class HealthDataTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSortingAsc: null,
      isStationIdAsc: true
    };
    this.detectOffline = this.detectOffline.bind(this);
    this.handleHealthData = this.handleHealthData.bind(this);
    this.handleOpenReportDialog = this.handleOpenReportDialog.bind(this);
    this.handleViewErrorReports = this.handleViewErrorReports.bind(this);
    this.handleSortStatus = this.handleSortStatus.bind(this);
    this.toggleSortOrder = this.toggleSortOrder.bind(this);
  }

  componentDidMount() {
    var intervalId = setInterval(this.detectOffline, 1000);

    const { fetchLatestHealthData, fetchLatestPRData, setOfflineIntervalId, stations, filterStatus, setInitialHealthData, fetchErrorTypes, errorTypes } = this.props;
    if (!errorTypes[ERROR_TYPE_NOT_CONNECTED])
      fetchErrorTypes();
    setInitialHealthData(stations);
    stations.forEach(station => {
      mqttMgr.addSubscriptionTopic(`${topicPrefix}${station.name}`, this.handleHealthData);
    });

    setOfflineIntervalId(intervalId);
    clearInterval(fetchHealthDataInterval)

    fetchLatestHealthData(stations);

    // Prepare the station names array for the request body
    const stationNames = stations.map(station => station.name);
    fetchLatestPRData({ stations: stationNames });
    
    const url = new URL(window.location.href);
    const status = url.searchParams.get("status");
    if (status !== null)
      filterStatus(parseInt(status, 10));

    fetchHealthDataInterval = setInterval(() => {
      fetchLatestHealthData(stations);

      const url = new URL(window.location.href);
      const status = url.searchParams.get("status");

      if (status !== null)
        filterStatus(parseInt(status, 10));
    }, 10000)
  }

  componentWillUnmount() {
    const { stations, clearOfflineIntervalId, offlineIntervalId } = this.props;
    clearOfflineIntervalId();
    clearInterval(offlineIntervalId);
    clearInterval(fetchHealthDataInterval);

    stations.forEach(station => {
      mqttMgr.removeSubscriptionTopic(`${topicPrefix}${station.name}`);
    });
  }

  handleHealthData = healthData => {
    const { setHealthData } = this.props;
    setHealthData(healthData);
  }

  handleOpenReportDialog = stationId => () => {
    const { toggleMessageDialog, selectStation } = this.props;
    selectStation(stationId);
    toggleMessageDialog();
  }

  handleSortStatus = event => {
    const { filterStatus } = this.props;
    const statusId = event.target.value;
    filterStatus(statusId);
  }

  toggleSortOrder = () => {
    this.setState(prevState => ({
      isSortingAsc: prevState.isSortingAsc === null ? false : !prevState.isSortingAsc
    }));
  }

  toggleStationSortOrder = () => {
    this.setState(prevState => ({
      isStationIdAsc: !prevState.isStationIdAsc,
      isSortingAsc: null
    }));
  }

  detectOffline = () => {
    const { liveHealthData, setErrorType } = this.props;
    const currentTimestamp = Date.parse(new Date().toLocaleString("en-US", { timeZone: "Asia/Singapore" })); // Convert any system time to SGT
    for (var i = 0; i < liveHealthData.length; i++) {
      if (liveHealthData[i].errorType !== ERROR_TYPE_NOT_CONNECTED) {
        var diffTimestamp = currentTimestamp - liveHealthData[i].timestamp;
        if (diffTimestamp > 300000) {// more than two min
          setErrorType(liveHealthData[i].stationId, ERROR_TYPE_NOT_CONNECTED);

          var healthPointer = document.getElementById(`point_${liveHealthData[i].stationId}`);
          if (healthPointer)
            healthPointer.style.backgroundColor = "#B71C1C";
        }
      }
    }
  }

  handleViewErrorReports = stationId => () => {
    this.props.history.push(`/station-error-reports/${btoa(stationId)}`);
  }
  render = () => {
  const { liveHealthData, latestPR, classes, errorTypes, getFilterStatusId, getIsSearching, stations } = this.props;
  const { isSortingAsc } = this.state;
  // Merge PR data with health data
  const liveHDataWithPR = liveHealthData.map(healthData => {
    const stationInfo = stations.find(station => station.name === healthData.stationId) || {};
    return {
      ...healthData,
      prData: latestPR[healthData.stationId]?.prData || null,
      description: stationInfo.description || ""  // Add description here
    };
  });

  // Default sorting by stationId in ascending order
  let liveHData = [...liveHDataWithPR];

  if (isSortingAsc !== null) {
    liveHData.sort((a, b) =>
      isSortingAsc ? a.prData - b.prData : b.prData - a.prData
    );
  } else {
    liveHData.sort((a, b) =>
      this.state.isStationIdAsc
        ? a.stationId.localeCompare(b.stationId)
        : b.stationId.localeCompare(a.stationId)
    );
  }
  // If sorting by PR is triggered, sort by PR data
  if (isSortingAsc !== null) {
    liveHData = liveHDataWithPR.sort((a, b) => isSortingAsc 
      ? (a.prData - b.prData)
      : (b.prData - a.prData)
    );
  }

  // Check if there are multiple stations
  const hasMultipleStations = stations.length > 1;

  return (
    <Page title={strings.lblStationsHealth}>
      {getIsSearching}
      <Paper>
        <Table className="healthDataTable">
          <TableHead>
            <TableRow>
              <TableCell width={200} style={tableHeadCellStyle}>
                {strings.lblStation}
                {hasMultipleStations && (
                  <IconButton onClick={this.toggleStationSortOrder} className="sortIconStylePR">
                    <UnfoldMoreIcon fontSize="inherit" />
                  </IconButton>
                )}
              </TableCell>
              <TableCell width={250} style={tableHeadCellStyle}>{strings.lblName}</TableCell>

              <TableCell width={150} style={tableHeadCellStyle}>PR
                {hasMultipleStations && (
                    <IconButton onClick={this.toggleSortOrder} className="sortIconStylePR">
                      <UnfoldMoreIcon fontSize="inherit" />
                    </IconButton>
                )}
              </TableCell>
              <TableCell width={250} style={tableHeadCellStyle}>{strings.lblLastOnline}</TableCell>
              <TableCell width={200} style={tableHeadCellStyle}>HB</TableCell>
              <TableCell style={tableHeadCellStyle}>
                <div style={{ display: 'inline-block', marginTop: '8px' }}> {strings.lblStatus} </div>
                <FormControl margin={strings.txtNormal} style={{ margin: '0px 10px', display: 'inline-block' }}>
                  <Select
                    value={getFilterStatusId}
                    onChange={this.handleSortStatus}
                  >
                    <MenuItem value={0}>All</MenuItem>
                    <MenuItem value={1}>Online</MenuItem>
                    <MenuItem value={200}>Warning</MenuItem>
                    <MenuItem value={-1}>Offline</MenuItem>
                  </Select>
                </FormControl>
              </TableCell>
              <TableCell style={tableHeadCellStyle}>{strings.lblReport}</TableCell>
              <TableCell style={tableHeadCellStyle}>{strings.lblSentReports}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {liveHData.map((healthData, index) => {
              if (healthData.errorType === getFilterStatusId || getFilterStatusId === 0 || (getFilterStatusId !== 1 && getFilterStatusId !== -1 && healthData.errorType !== 1 && healthData.errorType !== -1)) {
                return (
                  <TableRow key={index}>
                    <TableCell>{healthData.stationId}</TableCell>
                    <TableCell>{healthData.description}</TableCell>
                    <TableCell>
                      {healthData.prData !== null ? `${healthData.prData.toFixed(1)}%` : "N/A"}
                    </TableCell>
                    <TableCell>{healthData.timestamp && format(healthData.timestamp, strings.dateTimeFormat)}</TableCell>
                    <TableCell><div className={classes.statusColorBox} style={{ background: healthData.errorType === ERROR_TYPE_NOT_CONNECTED ? "#B71C1C" : (healthData.errorType === 1 ? "#00C853" : "#FB8C00") }} /></TableCell>
                    <TableCell>{errorTypes[healthData.errorType.toString()] || "..."}</TableCell>
                    <TableCell>
                      <IconButton color={strings.colorPrimary} onClick={this.handleOpenReportDialog(healthData.stationId)}>
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <IconButton color={strings.colorPrimary} onClick={this.handleViewErrorReports(healthData.stationId)}>
                        <ReportProblemIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              }
              return null;
            })}
          </TableBody>
        </Table>
      </Paper>
    </Page>
  );
}
}

const mapStateToProps = state => ({
  liveHealthData: reducers.getLiveHealthDataList(state),
  getErrorTypeList: reducers.getErrorTypeList(state),
  getFilterStatusId: reducers.getFilterStatusId(state),
  errorTypes: reducers.getErrorTypes(state),
  offlineIntervalId: reducers.getOfflineIntervalId(state),
  getIsSearching: reducers.getIsSearching(state),
  latestPR: reducers.getLatestPR(state),
  stations: userStationsReducers.getStations(state),
});

export default connect(mapStateToProps, {
  ...actionMgr,
  toggleMessageDialog: errorReprotDialogActionMgr.toggleMessageDialog,
  filterStatus: actionMgr.filterStatus
})(
  withStyles(styles)(
    withRouter(HealthDataTable)
  )
);